import React from 'react';
import { imageUrl } from '@terveystalo/design-system-cdn';
import { theme } from '@terveystalo/design-system-theme';
import { classnames } from '../../utils';
import { useColorFilter } from '../../css-utils/use-color-filter';
// Checks if a color name is included in the generated icon colors
const isSupportedColor = (color) => Object.keys(theme.color).includes(color);
/**
 * Icon component which extends the native img element. The icon shape can be changed with
 * the `name` prop which also provides the types the available icons.
 *
 * The icons are actually hosted externally in order to keep bundle sizes
 * smaller and benefit from a shared cache.
 * The downside of this is that all styling options for the icons are not available.
 */
export function Icon(props) {
    const { name, color, style, ...rest } = props;
    const colorOrDefault = !color || color == '' ? 'lake' : color;
    if (isSupportedColor(colorOrDefault)) {
        return (React.createElement("img", { src: imageUrl('icons', name, { color: colorOrDefault }), style: {
                width: theme.spacing['1_5'],
                height: theme.spacing['1_5'],
                ...style,
            }, alt: "", "aria-hidden": true, ...rest }));
    }
    return React.createElement(ColoredIcon, { name: name, targetColor: colorOrDefault, style: style, ...rest });
}
/**
 * Provides alternative icon which calculates css filters to recolor a white version of the icon.
 */
const ColoredIcon = ({ name, targetColor, className, style, ...rest }) => {
    const { component, filter } = useColorFilter({ color: targetColor, id: ['icon', name] });
    return (React.createElement(React.Fragment, null,
        component,
        React.createElement("img", { className: classnames(className), style: {
                width: theme.spacing['1_5'],
                height: theme.spacing['1_5'],
                filter,
                ...style,
            }, 
            // TODO: Replace this with 'black' once https://github.com/terveystalo/shared-design-system/pull/127 is merged
            src: imageUrl('icons', name, { color: 'white' }), alt: "", "aria-hidden": true, ...rest })));
};
